module.exports = __webpack_public_path__ + "img/sbg02.8f36583d.png";